import type { FC, PropsWithChildren } from 'react'

export const AppProviders: FC<PropsWithChildren> = props => {
  const { children } = props
  return <>{children}</>
}
